import { useEffect, useState } from 'react';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import { ContentPhoto } from '../ContentPhoto/ContentPhoto';

interface IPhotoGalleryProps {
  photoNames: string[];
}

const PhotoGallery = ({ photoNames }: IPhotoGalleryProps) => {
  const [images, setImages] = useState<ReactImageGalleryItem[]>();

  useEffect(() => {
    const photos = photoNames?.map((i) => {
      return {
        original: i,
        renderItem: () => {
          return <ContentPhoto url={i} height="750px" width='750px' />;
        },
      };
    });
    setImages(photos);
  }, []);

  return (
    <div>
      <ImageGallery
        items={images ?? []}
        showBullets={true}
        showFullscreenButton={false}
        showPlayButton={false}
        showThumbnails={false}
      />
    </div>
  );
};

export default PhotoGallery;
